/* ==========================================================================
   Ellashes — JavaScript du thème
   Aucune dépendance externe.
   ========================================================================== */
(function () {
  'use strict';

  /* Gabarits monétaires Shopify : [décimales, séparateur de milliers, séparateur décimal] */
  var MONEY_RULES = {
    amount: [2, ',', '.'],
    amount_no_decimals: [0, ',', '.'],
    amount_with_comma_separator: [2, '.', ','],
    amount_no_decimals_with_comma_separator: [0, '.', ','],
    amount_with_apostrophe_separator: [2, "'", '.'],
    amount_no_decimals_with_space_separator: [0, ' ', ','],
    amount_with_space_separator: [2, ' ', ','],
    amount_with_period_and_space_separator: [2, ' ', '.']
  };

  var group = function (amount, decimals, thousands, decimal) {
    var parts = Math.abs(amount).toFixed(decimals).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return (amount < 0 ? '-' : '') + (parts[1] ? whole + decimal + parts[1] : whole);
  };

  var money = function (cents) {
    var format = (window.EllashesTheme && window.EllashesTheme.moneyFormat) || '{{amount_with_comma_separator}} €';
    var amount = Number(cents) / 100;
    if (!isFinite(amount)) amount = 0;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (token, name) {
      var rule = MONEY_RULES[name];
      return rule ? group(amount, rule[0], rule[1], rule[2]) : token;
    });
  };

  var t = function (key, fallback) {
    var strings = (window.EllashesTheme && window.EllashesTheme.strings) || {};
    return strings[key] || fallback;
  };

  var routes = function () {
    return (window.EllashesTheme && window.EllashesTheme.routes) || {};
  };

  /* ----------------------------------------------------------------------
     Utilitaires
     ---------------------------------------------------------------------- */
  // Attache un écouteur une seule fois par élément (l'éditeur de thème relance init()).
  function bind(el, event, handler, key) {
    if (!el) return;
    var flag = '__bound_' + (key || event);
    if (el[flag]) return;
    el[flag] = true;
    el.addEventListener(event, handler);
  }

  function on(selector, event, handler, root) {
    (root || document).querySelectorAll(selector).forEach(function (el) {
      bind(el, event, handler, event + selector);
    });
  }

  function lockScroll(lock) {
    document.documentElement.classList.toggle('no-scroll', lock);
    document.body.classList.toggle('no-scroll', lock);
  }

  /* ----------------------------------------------------------------------
     Menu mobile
     ---------------------------------------------------------------------- */
  function initMobileNav() {
    var nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;

    function toggle(open) {
      nav.classList.toggle('is-open', open);
      nav.setAttribute('aria-hidden', open ? 'false' : 'true');
      lockScroll(open);
    }

    on('[data-mobile-nav-open]', 'click', function () {
      toggle(true);
    });
    on('[data-mobile-nav-close]', 'click', function () {
      toggle(false);
    });
    bind(nav.querySelector('.mobile-nav__overlay'), 'click', function () {
      toggle(false);
    });
    bind(
      document,
      'keydown',
      function (e) {
        if (e.key !== 'Escape') return;
        var current = document.querySelector('[data-mobile-nav]');
        if (!current) return;
        current.classList.remove('is-open');
        current.setAttribute('aria-hidden', 'true');
        lockScroll(false);
      },
      'keydown-mobile-nav'
    );
  }

  /* ----------------------------------------------------------------------
     Tiroir panier
     ---------------------------------------------------------------------- */
  var CartDrawer = {
    el: null,

    init: function () {
      this.el = document.querySelector('[data-cart-drawer]');
      if (!this.el) return;

      var self = this;
      on('[data-cart-open]', 'click', function (e) {
        if (self.el) {
          e.preventDefault();
          self.open();
        }
      });
      on('[data-cart-close]', 'click', function () {
        self.close();
      });
      bind(this.el.querySelector('.cart-drawer__overlay'), 'click', function () {
        self.close();
      });
      bind(
        document,
        'keydown',
        function (e) {
          if (e.key === 'Escape') CartDrawer.close();
        },
        'keydown-cart-drawer'
      );

      this.bindItems();
    },

    open: function () {
      if (!this.el) return;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      lockScroll(true);
    },

    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      lockScroll(false);
    },

    bindItems: function () {
      var self = this;
      on(
        '[data-cart-change]',
        'click',
        function (e) {
          e.preventDefault();
          var btn = e.currentTarget;
          self.change(btn.getAttribute('data-line'), btn.getAttribute('data-qty'));
        },
        this.el
      );
    },

    change: function (line, quantity) {
      var self = this;
      fetch(routes().cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
      })
        .then(function (r) {
          return r.json();
        })
        .then(function () {
          self.refresh();
        });
    },

    refresh: function () {
      var self = this;
      return fetch(routes().cart + '?section_id=cart-drawer')
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer-content]');
          var current = self.el && self.el.querySelector('[data-cart-drawer-content]');
          if (fresh && current) {
            current.innerHTML = fresh.innerHTML;
            self.bindItems();
          }
          return fetch(routes().cart + '.js');
        })
        .then(function (r) {
          return r ? r.json() : null;
        })
        .then(function (cart) {
          if (!cart) return;
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
          });
          // Rafraîchit la page panier si on s'y trouve.
          if (document.body.classList.contains('template-cart')) window.location.reload();
        });
    }
  };

  /* ----------------------------------------------------------------------
     Ajout au panier (AJAX)
     ---------------------------------------------------------------------- */
  function initAddToCart() {
    on('[data-product-form]', 'submit', function (e) {
      var form = e.currentTarget;
      if (!CartDrawer.el) return; // pas de tiroir → soumission classique
      e.preventDefault();

      var button = form.querySelector('[data-add-button]');
      var errorEl = form.querySelector('[data-form-error]');
      if (errorEl) errorEl.hidden = true;
      if (button) {
        button.classList.add('is-loading');
        button.setAttribute('aria-disabled', 'true');
      }

      fetch(routes().cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, data: data };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            if (errorEl) {
              errorEl.textContent = res.data.description || res.data.message || t('cartError', 'Une erreur est survenue.');
              errorEl.hidden = false;
            }
            return;
          }
          return CartDrawer.refresh().then(function () {
            CartDrawer.open();
          });
        })
        .catch(function () {
          if (errorEl) {
            errorEl.textContent = t('cartError', 'Une erreur est survenue.');
            errorEl.hidden = false;
          }
        })
        .finally(function () {
          if (button) {
            button.classList.remove('is-loading');
            button.removeAttribute('aria-disabled');
          }
        });
    });
  }

  /* ----------------------------------------------------------------------
     Sélecteur de variantes
     ---------------------------------------------------------------------- */
  function initVariants() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var dataEl = document.getElementById(picker.getAttribute('data-variants-id'));
      if (!dataEl) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }

      // Chaque bloc produit est autonome : accueil et page produit peuvent coexister.
      var root = (picker.closest && picker.closest('[data-product-root]')) || document;
      var updateUrl = root.hasAttribute ? root.hasAttribute('data-update-url') : false;

      var form = root.querySelector('[data-product-form]');
      var idInput = form && form.querySelector('[data-variant-id]');
      var priceEl = root.querySelector('.product__info [data-product-price]');
      var button = form && form.querySelector('[data-add-button]');
      var buttonText = button && button.querySelector('[data-add-text]');
      var skuEl = root.querySelector('[data-product-sku]');
      var stickyPrice = root.querySelector('[data-sticky-price]');

      function selectedOptions() {
        return Array.prototype.map.call(picker.querySelectorAll('fieldset'), function (fs) {
          var checked = fs.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }

      function update() {
        var opts = selectedOptions();

        // Libellé de l'option sélectionnée
        picker.querySelectorAll('fieldset').forEach(function (fs, i) {
          var label = fs.querySelector('[data-option-value]');
          if (label) label.textContent = opts[i] || '';
        });

        var match = variants.filter(function (v) {
          return v.options.every(function (opt, i) {
            return opt === opts[i];
          });
        })[0];

        // Grise les combinaisons indisponibles en tenant compte des options déjà choisies
        picker.querySelectorAll('fieldset').forEach(function (fs, index) {
          fs.querySelectorAll('input').forEach(function (input) {
            var exists = variants.some(function (v) {
              if (!v.available) return false;
              if (v.options[index] !== input.value) return false;
              for (var i = 0; i < index; i++) {
                if (opts[i] !== null && v.options[i] !== opts[i]) return false;
              }
              return true;
            });
            input.disabled = input.checked ? false : !exists;
          });
        });

        if (!match) {
          if (button) {
            button.setAttribute('aria-disabled', 'true');
            if (buttonText) buttonText.textContent = t('unavailable', 'Indisponible');
          }
          return;
        }

        if (idInput) idInput.value = match.id;

        // URL sans rechargement — seulement sur la page produit, jamais sur l'accueil
        if (updateUrl && window.history.replaceState && match.url) {
          window.history.replaceState({}, '', match.url);
        }

        if (priceEl) {
          var html = '<span class="price__current">' + money(match.price) + '</span>';
          if (match.compare_at_price && match.compare_at_price > match.price) {
            html += '<s class="price__compare">' + money(match.compare_at_price) + '</s>';
            var pct = Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100);
            html += '<span class="price__save">-' + pct + '%</span>';
          }
          priceEl.innerHTML = html;
          priceEl.classList.toggle('price--on-sale', !!(match.compare_at_price && match.compare_at_price > match.price));
        }

        if (stickyPrice) stickyPrice.textContent = money(match.price);
        if (skuEl) skuEl.textContent = match.sku || '';

        if (button) {
          if (match.available) {
            button.removeAttribute('aria-disabled');
            if (buttonText) buttonText.textContent = button.getAttribute('data-default-text') || t('addToCart', 'Ajouter au panier');
          } else {
            button.setAttribute('aria-disabled', 'true');
            if (buttonText) buttonText.textContent = t('soldOut', 'Rupture de stock');
          }
        }

        // Image liée à la variante
        if (match.featured_image_id) {
          var thumb = root.querySelector('[data-thumb][data-media-id="' + match.featured_image_id + '"]');
          if (thumb) thumb.click();
        }
      }

      bind(picker, 'change', update, 'variant-change');
      update();
    });
  }

  /* ----------------------------------------------------------------------
     Galerie produit
     ---------------------------------------------------------------------- */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var images = gallery.querySelectorAll('[data-gallery-image]');
      var thumbs = gallery.querySelectorAll('[data-thumb]');

      thumbs.forEach(function (thumb) {
        bind(thumb, 'click', function () {
          var id = thumb.getAttribute('data-media-id');
          images.forEach(function (img) {
            img.classList.toggle('is-active', img.getAttribute('data-media-id') === id);
          });
          thumbs.forEach(function (other) {
            other.classList.toggle('is-active', other === thumb);
          });
        });
      });
    });
  }

  /* ----------------------------------------------------------------------
     Quantité
     ---------------------------------------------------------------------- */
  function initQuantity() {
    on('[data-qty-change]', 'click', function (e) {
      var btn = e.currentTarget;
      var input = btn.parentElement.querySelector('input');
      if (!input) return;
      var value = parseInt(input.value, 10) || 1;
      value += parseInt(btn.getAttribute('data-qty-change'), 10);
      input.value = Math.max(parseInt(input.min, 10) || 1, value);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ----------------------------------------------------------------------
     Accordéons
     ---------------------------------------------------------------------- */
  function initAccordions() {
    on('[data-accordion-trigger]', 'click', function (e) {
      var trigger = e.currentTarget;
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      var open = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) panel.setAttribute('data-open', open ? 'false' : 'true');
    });
  }

  /* ----------------------------------------------------------------------
     Barre d'achat collante
     ---------------------------------------------------------------------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    ).observe(anchor);

    bar.querySelector('[data-sticky-add]').addEventListener('click', function () {
      var form = document.querySelector('[data-product-form]');
      if (!form) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });
  }

  /* ----------------------------------------------------------------------
     Compte à rebours
     ---------------------------------------------------------------------- */
  function initCountdown() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var minutes = parseInt(el.getAttribute('data-minutes'), 10) || 15;
      var key = 'ellashes-countdown';
      var end = parseInt(sessionStorage.getItem(key), 10);
      var now = Date.now();

      if (!end || isNaN(end) || end < now) {
        end = now + minutes * 60000;
        try {
          sessionStorage.setItem(key, String(end));
        } catch (err) {
          /* mode privé */
        }
      }

      var fields = {
        hours: el.querySelector('[data-cd-hours]'),
        minutes: el.querySelector('[data-cd-minutes]'),
        seconds: el.querySelector('[data-cd-seconds]')
      };

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function tick() {
        var diff = Math.max(0, end - Date.now());
        var totalSeconds = Math.floor(diff / 1000);
        if (fields.hours) fields.hours.textContent = pad(Math.floor(totalSeconds / 3600));
        if (fields.minutes) fields.minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
        if (fields.seconds) fields.seconds.textContent = pad(totalSeconds % 60);
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  /* ----------------------------------------------------------------------
     Barre d'annonce défilante
     ---------------------------------------------------------------------- */
  function initAnnouncement() {
    document.querySelectorAll('[data-announcement]').forEach(function (bar) {
      var slides = bar.querySelectorAll('.announcement__slide');
      if (slides.length < 2) return;
      var index = 0;
      setInterval(function () {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, 4500);
    });
  }

  /* ----------------------------------------------------------------------
     Animations à l'apparition
     ---------------------------------------------------------------------- */
  function initAnimations() {
    var items = document.querySelectorAll('[data-animate]');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -60px 0px' }
    );
    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ----------------------------------------------------------------------
     Recherche (en-tête)
     ---------------------------------------------------------------------- */
  function initSearch() {
    var toggle = document.querySelector('[data-search-toggle]');
    var panel = document.querySelector('[data-search-panel]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      var open = panel.hasAttribute('hidden');
      if (open) {
        panel.removeAttribute('hidden');
        var input = panel.querySelector('input');
        if (input) input.focus();
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  /* ----------------------------------------------------------------------
     Init
     ---------------------------------------------------------------------- */
  function init() {
    initMobileNav();
    CartDrawer.init();
    initAddToCart();
    initVariants();
    initGallery();
    initQuantity();
    initAccordions();
    initStickyAtc();
    initCountdown();
    initAnnouncement();
    initAnimations();
    initSearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Ré-initialisation dans l'éditeur de thème
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
